import * as React from "react";

function SvgChipDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M16.154 2.25a.75.75 0 01.743.648l.007.102v1.651a4.776 4.776 0 012.444 2.445H21a.75.75 0 01.102 1.493L21 8.596h-1.268l.013.2.005.204v.865H21a.75.75 0 01.102 1.494l-.102.007-1.25-.001v1.269H21a.75.75 0 01.102 1.494l-.102.007-1.25-.001v.868c0 .135-.006.27-.018.402H21a.75.75 0 01.102 1.493l-.102.007h-1.651a4.776 4.776 0 01-2.445 2.444V21a.75.75 0 01-1.493.102L15.404 21v-1.268l-.2.013-.204.005h-.866V21a.75.75 0 01-1.492.102L12.635 21l-.001-1.25h-1.269V21a.75.75 0 01-1.493.102L9.866 21l-.001-1.25h-.867c-.135 0-.27-.006-.402-.018V21a.75.75 0 01-1.493.102L7.096 21v-1.651a4.776 4.776 0 01-2.444-2.445H3a.75.75 0 01-.102-1.493L3 15.404h1.268l-.013-.2L4.25 15v-.866H3a.75.75 0 01-.102-1.492L3 12.635l1.25-.001v-1.269H3a.75.75 0 01-.102-1.493L3 9.866l1.25-.001v-.867c0-.135.006-.27.018-.402H3a.75.75 0 01-.102-1.493L3 7.096h1.651a4.776 4.776 0 012.445-2.444V3a.75.75 0 011.493-.102L8.596 3v1.268l.2-.013L9 4.25h.865V3a.75.75 0 011.494-.102l.007.102-.001 1.25h1.269V3a.75.75 0 011.494-.102l.007.102-.001 1.25h.868c.135 0 .27.006.402.018V3a.75.75 0 01.75-.75zM14 8.75h-3.998a1.256 1.256 0 00-1.245 1.123L8.75 10v3.998c.002.647.494 1.18 1.123 1.245l.127.007h3.998a1.256 1.256 0 001.245-1.123L15.25 14v-3.998a1.256 1.256 0 00-1.123-1.245L14 8.75z"
        />
        <path
          fill="#98DB69"
          d="M15 5.75l.184.006a3.262 3.262 0 013.066 3.246V15l-.006.184a3.262 3.262 0 01-3.246 3.066H9l-.184-.006a3.262 3.262 0 01-3.066-3.246V9l.006-.184A3.262 3.262 0 019.002 5.75H15zm-.998 1.5H10l-.167.005A2.756 2.756 0 007.25 9.998V14l.005.167a2.756 2.756 0 002.743 2.583H14l.167-.005a2.756 2.756 0 002.583-2.743V10l-.005-.167a2.756 2.756 0 00-2.743-2.583z"
        />
      </g>
    </svg>
  );
}

export default SvgChipDuo;
